// config/apiConfig.js

const API_URL = 'https://apiscm.asrlanka.com';
// const API_URL = 'https://dev.apiscm.asrlanka.com';
// const API_URL = 'http://localhost:8000';


export default API_URL;
